import SubmissionStatus from '../Data/SubmissionStatus';
import { setPartialSubmissionStatus } from '../Lib/redux/slices/submission';
import { getSubmissionArgs } from './submission';
import { submitStandardLeadWithPartialData } from './submitLead.helpers';

const submitPartialLead = ({
  campaignId,
  components,
  consentedLegalStatementHash,
  countryCode,
  dispatch,
  formId,
  oneTrustLocale,
  pageUrl,
  parentPageCookies,
  phoneNumberCountryCode,
  referrerUrl,
  sourceSite,
  submitLeadMutation,
  testMode,
  useCidFromURL,
  widgetLabel,
  multipleSupplierConsentedLegalStatementHash,
  singleSupplierConsentedLegalStatementHash,
  consentCertification,
  supplierId,
  visitorId,
  consentStatement,
  privacyPolicyUrl,
  subcategoryName,
  firstSubmissionAttemptTimestamp,
  subcategoryId,
  matchLevel,
  selectAndConnectBrand,
  iFrameId,
  partialSubmissionPage,
  supplierMatchSelectionEnabled,
  isDomainInternal,
  themeName,
  featureFlags,
}) => {
  dispatch(
    setPartialSubmissionStatus({
      partialSubmissionStatus: SubmissionStatus.IN_PROGRESS,
    })
  );

  const submissionArgs = getSubmissionArgs({
    campaignId,
    components,
    consentedLegalStatementHash,
    consentedSuppliersHash: '',
    countryCode,
    formId,
    phoneNumberCountryCode,
    sourceSite,
    testMode,
    pageUrl,
    referrerUrl,
    widgetLabel,
    useCidFromURL,
    parentPageCookies,
    oneTrustLocale,
    multipleSupplierConsentedLegalStatementHash,
    singleSupplierConsentedLegalStatementHash,
    consentCertification,
    supplierId,
    consentStatement,
    privacyPolicyUrl,
    subcategoryName,
    subcategoryId,
    matchLevel,
    selectAndConnectBrand,
    isPartial: true,
    supplierMatchSelectionEnabled,
    themeName,
    featureFlags,
  });

  submitStandardLeadWithPartialData({
    submitLeadMutation,
    submissionArgs,
    dispatch,
    visitorId,
    firstSubmissionAttemptTimestamp,
    iFrameId,
    partialSubmissionPage,
    components,
    isDomainInternal,
  });
};

export default submitPartialLead;
